export const DE_TRANSLATE = {
    "HELLO": "Hallo",
    "back": "Zurück",
    "ok": "Ok",
    "cancel": "Abbrechen",
    "startBtn": "Starten",

    "detox": "Detox",
    "detoxPlan": "Menüs und Rezepte",
    "settings": "Einstellungen",
    "shoppingList": "Einkaufsliste",
    "termsOfUse": "Nutzungsbedingungen",
    "guides": "Anleitungen",
    "aboutUs": "Über uns",
    "slogan": "21 Tage gesunde Körperreinigung",

    "dailyMenu": "Tägliches Menü",
    "day": "Tag",
    "finish": "Was jetzt",
    "ingredients": "Zutaten",
    "instructions": "Anweisungen",
    "intro": "Einführung",
    "markThisDay": "Diesen Tag als erledigt markieren",
    "serving": "Portion",
    "servings": "Portionen",
    "meals": [
        {
            "name": "Frühstück"
        },
        {
            "name": "Vormittags"
        },
        {
            "name": "Mittagessen"
        },
        {
            "name": "Nachmittag"
        },
        {
            "name": "Abendessen"
        }
    ],

    "more": "mehr",
    "language": "Sprache",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Einheit",
    "selectDetoxPlan": "Wählen Sie Ihren Detox-Plan",
    "detoxPlans": "Detox-Pläne",
    "restart": "Neustart",
    "start": "Start",
    "days": "Tage",
    "standard": "Standard",
    "vegan": "Vegan",
    "vegetarian": "Vegetarisch",
    "pescetarian": "Pescetarisch",
    "wellDone": "Gut gemacht!",
    "whatsNow": "Was jetzt",

    "youDidIt": "Gut gemacht, du hast es geschafft",
    "weProud": "Wir sind stolz auf dich,",
    "presentYourself": "Du hast dir ein tolles Geschenk gemacht",

    "messages": {
        "resetApp": {
            "title": "App zurücksetzen",
            "content": "Diese Aktion setzt die Einkaufsliste und die als erledigt markierten Tage zurück.\nDrücken Sie OK, wenn Sie die App zurücksetzen möchten."
        }
    },
}
